import { bindOn } from 'chimera/all/plugins/eventbus/events/bind'
import { getEventScope } from 'chimera/all/plugins/eventbus/scope'
import { emit } from './emit'

/**
 * @type {string}
 */
export const formAllNameFieldsValidEvent = 'eb_formAllNameFieldsValid'

/**
 * @param {string[]} fields
 */
export function emitFormAllNameFieldsValidEvent(fields) {
  emitFormAllNameFieldsValidEventInScope(getEventScope(), fields)
}

/**
 * @param {object} scope
 * @param {string[]} fields
 */
export function emitFormAllNameFieldsValidEventInScope(scope, fields) {
  emit(formAllNameFieldsValidEvent, {
    fields,
    scope,
  })
}

/**
 * @param {Function} callback
 */
export function onFormAllNameFieldsValidEvent(callback) {
  bindOn(formAllNameFieldsValidEvent, callback)
}
